import logo from './logo.svg';
import './App.css';
import Qrcode from './Qrcode';

function App() {
  return (
	<Qrcode/>
  );
}

export default App;
